import { getNestedProperty } from '@opallabs/lambda'
import { getEntityDataByViewState } from '../entities/generic'

export const getPersonalPanelState = (state) =>
  getEntityDataByViewState(state).personalPanel || undefined
export const getPersonalPanelLoadingStates = (state) => {
  const personalPanelState = getPersonalPanelState(state)

  if (personalPanelState === undefined) return null

  const loadingStateByViewKey = (viewKey) =>
    getNestedProperty(personalPanelState, viewKey, 'loadingState')
  const loaderIsLoading = (loadingState) =>
    [undefined, 'loading'].includes(loadingState)

  return {
    tasks: {
      todo: loaderIsLoading(loadingStateByViewKey('tasks.todo')),
      overdue: loaderIsLoading(loadingStateByViewKey('tasks.overdue')),
      upcoming: loaderIsLoading(loadingStateByViewKey('tasks.upcoming')),
      completed: loaderIsLoading(loadingStateByViewKey('tasks.todo')),
    },
    approvals: {
      pending: loaderIsLoading(loadingStateByViewKey('approvals.pending')),
      overdue: loaderIsLoading(loadingStateByViewKey('approvals.overdue')),
      completed: loaderIsLoading(loadingStateByViewKey('approvals.completed')),
    },
  }
}
